import { render, staticRenderFns } from "./ThgMyVehicles.vue?vue&type=template&id=2b9f6532"
import script from "./ThgMyVehicles.vue?vue&type=script&lang=ts"
export * from "./ThgMyVehicles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports